import { IAgent } from 'interfaces/agents';
import { getAPI } from 'requests/api';

export const me = async (): Promise<IAgent> => {
  const { data } = await getAPI().get(`/admin/agents/me`);

  return data;
};
